import script from "./ElementFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementFilter.vue?vue&type=script&lang=ts&setup=true"

import "./ElementFilter.vue?vue&type=style&index=0&id=2c8acf3c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8acf3c"]])

export default __exports__